export const formatSynergy = (num: number) => {
  const fixed = (num * 100).toFixed(0)

  return fixed === '-0' ? '0' : fixed
}
